import React, { createContext, useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import translations from "./translations";

export const LANGUAGES = [
  { code: "pt", htmlLang: "pt-BR", label: "Português (Brasil)", flag: "/images/flags/br.png" },
  { code: "en", htmlLang: "en-US", label: "English (US)", flag: "/images/flags/us.png" },
];

const COOKIE_NAME = "lang";

// A saved choice wins; otherwise Portuguese browsers get Portuguese, everyone else English.
function detectLanguage() {
  const saved = Cookies.get(COOKIE_NAME);
  if (translations[saved]) return saved;

  const preferred = (navigator.languages && navigator.languages[0]) || navigator.language || "";
  return preferred.toLowerCase().startsWith("pt") ? "pt" : "en";
}

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectLanguage);

  useEffect(() => {
    const current = LANGUAGES.find((l) => l.code === lang);
    document.documentElement.lang = current ? current.htmlLang : lang;
  }, [lang]);

  const setLang = (code) => {
    if (!translations[code]) return;
    setLangState(code);
    Cookies.set(COOKIE_NAME, code, { expires: 365, sameSite: "Lax" });
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used inside <LanguageProvider>");
  return context;
}
